import React, { useState } from 'react'

function ContactForm() {
    const [Detail, upDetail] = useState({
        name: "",
        email: "",
        message: ""
    })
    const [submission, upsubmission] = useState("");
    let name, value;
    const dataInsert = (event) => {
        name = event.target.name;
        value = event.target.value;
        upDetail({ ...Detail, [name]: value })
    }
    const dataBaseName = "userData.json";
    //connecting databse and passing my own like database name
    const submitData = async (event) => {
        event.preventDefault();
        const { name, email, message } = Detail;//destructuring object data
        if(name!=="" && email!=="" && message!==""){
        const res = fetch(`https://abufaishal3087-portfolio-default-rtdb.firebaseio.com/${dataBaseName}`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    name,
                    email,
                    message
                })
            })
        if (res)
            upsubmission("Success");
        else
            upsubmission("Failed");

        //clearing input boxes after submission
        upDetail({
            name: "",
            email: "",
            message: ""
        });
    }
    else{
        alert("please fill all the fields");
    }
    }

    return (
        <>
            <div className="row mt-5">
                <div className="col text-center">
                    <p className="h2">Contact Me</p>
                    <p className="text-primary">Get in touch</p>
                </div>
            </div>
            <div className="row mt-3 mb-3">
                <div className="col-md-6">
                    <div className="leftdiv">
                        <div className="call">
                            <img src="https://cdn-icons-png.flaticon.com/512/724/724664.png" alt="icon" />
                            <div>
                                <h4>Call Me</h4>
                                <p className="text-muted">7903374117</p>
                            </div>
                        </div>
                        <div className="email">
                            <img src="https://cdn-icons-png.flaticon.com/512/732/732200.png" alt="icon" />
                            <div>
                                <h4>Email</h4>
                                <p className="text-muted">faishalhussain3087@gmail.com</p>
                            </div>
                        </div>
                        <div className="location">
                            <img src="https://cdn-icons-png.flaticon.com/512/684/684908.png" alt="icon" />
                            <div>
                                <h4>Location</h4>
                                <p className="text-muted">India - Lodna more,Dhanbad,Jharkhand,<br />828301</p>
                            </div>
                        </div>
                    </div>
                </div>
                <div className=" col-md-6 ">
                    <form action="">
                        {
                            submission === "Success" ? <>
                                <div className="alert_of_sended">
                                    <h5>Message sended <img src="https://cdn-icons-png.flaticon.com/512/3472/3472620.png" width="35px" alt="" /></h5>
                                    <div>
                                        <button onClick={() => upsubmission("")}>Ok</button>
                                    </div>
                                </div>
                            </> : submission === "Failed" ? <>
                                <div className="alert_of_failed">
                                    <h5>Sending failed <img src="https://img-premium.flaticon.com/png/512/1008/premium/1008927.png?token=exp=1633277820~hmac=189bf9d568d1825271ccc727a607f570" width="35px" alt="" /></h5>
                                    <div>
                                        <button onClick={() => upsubmission("")}>Ok</button>
                                    </div>
                                </div>
                            </> :
                                <div className="rightdiv">
                                    <div className="name form-group">
                                        <input name="name" value={Detail.name} onChange={dataInsert} type="text" className="form-control" placeholder="Name.." required />
                                    </div>
                                    <div className="cemail form-group">
                                        <input name="email" value={Detail.email} onChange={dataInsert} type="email" className="form-control" placeholder="Email.." required />
                                    </div>
                                    <div className="message form-group">
                                        <textarea name="message" value={Detail.message} onChange={dataInsert} className="form-control" placeholder="Message" rows="4" cols="50" required />
                                    </div>
                                    <button type="submit" onClick={submitData} className="btn btn-success">Send <img src="https://cdn-icons-png.flaticon.com/512/561/561226.png" width="20px" alt="" /></button>
                                </div>
                        }
                    </form>
                </div>
            </div>
        </>
    )
}

export default ContactForm
